import { GridContainer, GridItem } from "../common/grids"
import Main from "../common/Main/Main"
import Tabs from "../common/TabSwich/Tabs"
import { configFile } from "./constants"
import { NotificationsProvider } from "./context/provider"
import { Wrapper } from "./styles"

const Notifications = () => {

  return (
    <Main>
      <NotificationsProvider>
        <Wrapper>
          <GridContainer className='container'>
            <GridItem lg={12}>
              <Tabs configFile={configFile} className='retention-tabs' activeTab={0} />
            </GridItem>
          </GridContainer>
        </Wrapper>
      </NotificationsProvider>
    </Main>
  )
}

export default Notifications

